'use strict';

const EMPTY_STRING = '';
const MANDATORY_SELECTION_VALIDATION_CHANGED_CLASS = 'mandatory_selection_validation_changed';
const MANDATORY_SELECTION_ERROR_DISPOSED_CLASS = 'od-ancillaries-module-mandatory-selection-error-disposed';
const Nag = require('../../../modules/ui/nag/nag');
const Modal = require('../../../modules/ui/modal');
const baseViewClass = Odigeo.View;
const viewOptions = ['widget', 'options', 'model'];
const MODAL_DUAL_CONTRACT_LINK_CLASS = 'show_modal_dual_contract';
const MODAL_DUAL_CONTRACT_CLASS = 'modal_dual_contract';
const MODAL_CLOSE_ON_OUTCLICK = false;
const MODAL_PRICE_DISPLAY = 'modals/common/priceDisplay';
const MODAL_PRICE_DISPLAY_FREE = 'modals/common/priceDisplayFree';
const logger = require('od-modules/utils/logger');
const {additionalProductsCatalog, trackOncePerPolicy} = require('od-modules/track_events/track.frontevents.additional.products');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

/**
 * @class AncillariesModuleViewBase
 * @extends Odigeo.View
 */
module.exports = baseViewClass.extend({
    tagName: 'div',
    modals: null,
    modalTemplateName: null,
    modalContent: 'modals/modalContent',
    hasMandatorySelectionDisplayedAtLeastOnce: false,
    events: {
        'click .ancillaries_add_button': 'onAncillariesButtonClickToggle',
        'click .see_modal': 'toggleModalHandler',
        'mousedown .conditions_link': 'onConditionsLinkClick',
        'mousedown .ipid_link': 'onIpidLinkClick',
        'click .ancillaries_back_button': 'onAncillariesBackButton',
    },

    selectors: {
        mandatorySelectionWrapper: '.mandatory_selection_error_wrapper',
        pendingDecisionMsg: '.pending_decision_message',
        ancillariesAddButton: '.ancillaries_add_button',
    },

    onAncillariesBackButton(e) {
        e.preventDefault();
        e.stopPropagation();
        Odigeo.History.history.back();
    },

    initialize(options) {
        Odigeo._.extend(options, Odigeo._.pick(this, ['el']));

        baseViewClass.prototype.initialize.call(this, options);

        Odigeo._.extend(this, Odigeo._.pick(options, viewOptions));

        this.modals = {};

        this.listenTo(this.model, 'change', this.refresh);
        this.listenTo(this.model, 'defaultNagAccepted', this.onNagAccepted);
        this.listenTo(this.model, 'defaultNagRejected', this.onNagRejected);
        this.listenTo(this.model, 'pendingDecisionError', this.onPendingDecision);

        this.on('refresh', this.handleMandatorySelectionAnimation);
    },

    handleMandatorySelectionAnimation() {
        const mandatorySelectionWrapper = this.$cachedSelectors.mandatorySelectionWrapper;
        const hasToDisplayError = this.model.getValidationFailed();

        if (mandatorySelectionWrapper.hasClass(MANDATORY_SELECTION_VALIDATION_CHANGED_CLASS)) {
            setTimeout(function() {
                mandatorySelectionWrapper
                    .removeClass(MANDATORY_SELECTION_VALIDATION_CHANGED_CLASS)
                    .toggleClass(MANDATORY_SELECTION_ERROR_DISPOSED_CLASS, !hasToDisplayError);
            }, 0);
        }
    },

    getTemplateName(template) {
        return template || this.model.getTemplate();
    },

    parseTextsAndAttributes(offer = {}) {
        this.parseBenefits(offer);
        this.parseFreeFlag(offer);
        this.parseFirstProduct(offer);

        if (this.model.hasIpid(offer)) {
            this.parseFooterIpidLink(offer);
        }

        offer.label = additionalProductsCatalog.ANCILLARIES_MODULE.label(offer.policy);
    },

    setButtonData() {
        return null;
    },

    parseBenefits(offer) {
        Odigeo._.extend(Odigeo._.get(offer, 'texts'), {
            parsedBenefits:
                Odigeo._.get(offer, 'texts.parsedBenefits') || this.parseBenefitsHtml(Odigeo._.get(offer, 'texts.benefits', EMPTY_STRING)),
            parsedFullBenefits: Odigeo._.get(offer, 'texts.parsedFullBenefits') || this.parseBenefitsHtml(Odigeo._.get(offer, 'texts.benefitsFull')),
        });
    },

    parseBenefitsHtml(benefits, ulClass) {
        ulClass = ulClass || 'odf-ul-mark odf-ul-mark-md';

        const $wrapper = $('<div>');
        $wrapper.html(benefits);

        const $valid = $('ul > li', $wrapper);
        $('li', $wrapper).not($valid).addClass('invalid_li');
        const $firstLiToBeWrapped = $('.invalid_li:first-child, *:not(.invalid_li) + .invalid_li, * > .invalid_li', $wrapper);

        $firstLiToBeWrapped.each(function() {
            $(this).nextUntil(':not(.invalid_li)').addBack().wrapAll('<ul/>');
        });

        $('ul', $wrapper).addClass(ulClass);
        $('li', $wrapper).removeClass('invalid_li').addClass('odf-li');

        return $wrapper.html();
    },

    extendModelBeforeRender() {
        const offer = this.model.toJSON();
        const products = this.model.isMultiOffer() ? offer.products : [offer];

        Odigeo._.each(products, this.parseTextsAndAttributes, this);

        return offer;
    },

    beforeInsertTemplate(data) {
        this.parseDataBeforeInsertTemplate(data);

        return {
            tmpl: data,
        };
    },

    parseDataBeforeInsertTemplate(data) {
        this.setButtonData(data);
        this.setTranslationsData(data);
        this.setHandLuggageData(data);
    },

    setTranslationsData(offer) {
        Odigeo._.extend(offer, {
            translations: this.keys || {},
        });
    },

    preRender() {
        this.lastParsedModelData = this.extendModelBeforeRender();
    },

    render() {
        this.setTemplate(this.$el, this.getTemplateName(), this.lastParsedModelData);
        return this;
    },

    postRender(modalContent = this.modalContent) {
        this.modalContent = modalContent;
        this.initModals(this.lastParsedModelData);

        this.$cachedSelectors.ancillariesAddButton.each((_, view) => trackOncePerPolicy($(view)));
    },

    initModals(modelData) {
        if (Odigeo._.isObject(modelData)) {
            const offers = this.model.isMultiOffer() ? Odigeo._.get(modelData, 'products') : [modelData];
            Odigeo._.each(offers, this.initOrRefreshModal, this);
        }
    },

    initOrRefreshModal(offer) {
        const policy = Odigeo._.get(offer, 'policy');
        const modal = this.modals[policy];

        if (this.model.hasModal()) {
            if (Odigeo._.isEmpty(modal)) {
                return this.initModal(offer).then(() => {
                    this.bindModalEvents(offer);
                });
            } else {
                const $modalContainer = this.getModalContainerByPolicy(policy);
                if (!Odigeo._.isEmpty($modalContainer)) {
                    return modal.modal.then((modalResult) => {
                        modalResult.updateContainer($modalContainer);
                        modal.container = $modalContainer;
                        this.bindModalEvents(offer);
                    });
                } else {
                    return Promise.resolve();
                }
            }
        } else {
            return Promise.resolve();
        }
    },

    initModal(offer) {
        const policy = Odigeo._.get(offer, 'policy');
        const $modalContainer = this.getModalContainerByPolicy(policy);

        if (!Odigeo._.isEmpty($modalContainer)) {
            const isFree = Odigeo._.get(offer, 'isFree');
            const priceContainer = isFree ? MODAL_PRICE_DISPLAY_FREE : MODAL_PRICE_DISPLAY;
            const modalData = this.getModalData(offer, isFree);
            const modal = new Modal($modalContainer,
                {
                    header: modalData.header,
                    content: this.getParsedTemplateContent(this.modalContent, modalData),
                    priceTemplate: this.getParsedTemplateContent(priceContainer, modalData),
                    button: modalData.button,
                },
                {
                    fillThePage: false,
                    template: this.getTemplateBuilder(this.modalTemplateName),
                    button: {
                        analytics: this.widget.tracking.getTrackData('add_from_details', policy),
                        callback: Odigeo._.bind(
                            function() {
                                this.toggleSelected(policy);
                            }, this.model),
                        hide: !this.model.canAddOfferFromModal(offer),
                    },
                    open: {
                        analytics: this.widget.tracking.getTrackData('open_details', policy),
                    },
                    close: {
                        analytics: this.widget.tracking.getTrackData('close_details', policy),
                    },
                });

            this.modals[policy] = {
                modal: modal,
                container: $modalContainer,
            };

            return modal;
        } else {
            return Promise.resolve();
        }
    },

    getModalData(offer, isFree) {
        const modalData = {
            hasModalExclusion: this.model.hasModalExclusion(offer),
            hasModalBenefits: this.model.hasModalBenefits(offer),
            hasDualContract: this.model.hasDualContract(offer),
            header: Odigeo._.get(offer, 'texts.modal.header', EMPTY_STRING),
            button: Odigeo._.get(offer, 'texts.modal.button', EMPTY_STRING),
            prices: {
                text: isFree ? Odigeo._.get(this.keys, 'pricePerBooking') : Odigeo._.get(offer.prices, 'text'),
                priceToDisplayFormatted: isFree ? Odigeo._.get(offer, 'texts.slashedPrice') : Odigeo._.get(offer.prices, 'priceToDisplayFormatted'),
                pillPrice: isFree ? Odigeo._.get(offer, 'texts.pillPrice') : EMPTY_STRING,
            },
        };

        this.generateModalExclusions(modalData, offer);
        this.generateModalBenefits(modalData, offer);

        return modalData;
    },

    generateModalBenefits(modalData, offer) {
        const benefits = Odigeo._.get(offer, 'texts.parsedFullBenefits', EMPTY_STRING) || Odigeo._.get(offer, 'texts.parsedBenefits', EMPTY_STRING);
        if (!!modalData.hasModalBenefits && !Odigeo._.isEmpty(benefits)) {
            modalData.benefits = benefits;
        }
    },

    generateModalExclusions(modalData, offer) {
        const exclusions = Odigeo._.get(offer, 'texts.modal.exclusions');
        if (!!modalData.hasModalExclusion && !Odigeo._.isEmpty(exclusions)) {
            Odigeo._.merge(modalData, {
                summary: Odigeo._.get(offer, 'texts.modal.summary', EMPTY_STRING),
                exclusions: this.parseExclusions(exclusions),
                links: {
                    summary: Odigeo._.get(offer, 'texts.modal.summaryLink', EMPTY_STRING),
                    extended: Odigeo._.get(offer, 'texts.modal.extendedLink', EMPTY_STRING),
                    summaryUrl: this.model.get('url'),
                    extendedUrl: this.model.get('urlExtended'),
                },
            });

            const dualContract = Odigeo._.get(offer, 'texts.modal.dualContract', EMPTY_STRING);
            if (!!modalData.hasDualContract && !Odigeo._.isEmpty(dualContract)) {
                Odigeo._.merge(modalData, {
                    constants: {
                        dualContractLinkClass: MODAL_DUAL_CONTRACT_LINK_CLASS,
                        dualContractClass: MODAL_DUAL_CONTRACT_CLASS,
                    },
                    dualContract: dualContract,
                    links: {
                        dualContract: Odigeo._.get(offer, 'texts.modal.dualContractLink', EMPTY_STRING),
                    },
                });
            }
        }
    },

    parseExclusions(exclusions) {
        let $exclusions;
        try {
            $exclusions = $('<div>', {html: exclusions});
            const $exclusionsElements = $exclusions.children();

            $exclusionsElements.filter('li').addClass('odf-li');
            $exclusionsElements.filter('p').find('> b').addClass('odf-row-fluid odf-space-inner-top-s odf-space-inner-top-m');
            $exclusionsElements.filter('ul').addClass('odf-ul-mark odf-ul-mark-md');
        } catch (error) {
            logger.error(error);
            $exclusions = $('<div>', {'text': exclusions});
        }

        return $exclusions.html();
    },

    toggleModalHandler(e) {
        const policy = this.getPolicyFromTarget(e.target);
        const modalObject = this.modals[policy];

        if (!Odigeo._.isEmpty(modalObject)) {
            const isNotSelected = !this.model.isSelected(policy);
            return modalObject.modal.then((modalResult) => {
                modalResult.open(isNotSelected, MODAL_CLOSE_ON_OUTCLICK);
            });
        } else {
            return Promise.resolve({});
        }
    },

    bindModalEvents(offer) {
        const policy = Odigeo._.get(offer, 'policy');
        const modal = Odigeo._.get(this.modals, policy, false);
        let $modalContainer;
        let $link;

        if (modal) {
            $modalContainer = modal.container;
            $link = $modalContainer.find('.link_conditions');

            $link.on(Odigeo.Events.tap, Odigeo._.bind(function(e) {
                this.trackModalConditionsLinkClick(e, policy);
            }, this));

            if (this.model.hasDualContract(offer)) {
                const $dualContractLink = $modalContainer.find('.' + MODAL_DUAL_CONTRACT_LINK_CLASS);
                $dualContractLink.on(Odigeo.Events.tap, Odigeo._.bind(function() {
                    this.showModalDualContract($modalContainer, policy);
                }, this));
            }
        }
    },

    trackModalConditionsLinkClick(evt, policy) {
        evt.stopPropagation();
        const type = $(evt.target).data('type');
        if (type === 'short') {
            this.widget.tracking.openConditionsShort(policy);
        } else {
            this.widget.tracking.openConditionsLong(policy);
        }
    },

    showModalDualContract($modalContainer, policy) {
        const $link = $modalContainer.find('.' + MODAL_DUAL_CONTRACT_LINK_CLASS);
        const $dualContract = $modalContainer.find('.' + MODAL_DUAL_CONTRACT_CLASS);

        $link.addClass('odf-hidden');
        $dualContract.removeClass('odf-hidden');
        this.widget.tracking.openConditionsMore(policy);
    },

    getModalContainerByPolicy(policy) {
        let $container;
        if (Odigeo._.isFunction(Odigeo._.get(this.$el, 'find'))) {
            $container = this.$el.find('.modal_container[data-policy="' + policy + '"]');
        }
        return $container && $container.length ? $container : null;
    },

    onAncillariesButtonClickToggle(e) {
        e.preventDefault();
        e.stopPropagation();

        const policy = this.getPolicyFromTarget(e.target);

        this.model.toggleSelected(policy);
        this.model.setLastPolicyInteractedWith(policy);
        trackClickEvent(e);
    },

    setLastPolicyInteractedWith() {
        this.model.setLastPolicyInteractedWith(this.model.getPolicyFromSimpleOffer());
    },

    getPolicyFromTarget(target) {
        return this.model.isMultiOffer() ? target.value : this.model.get('policy');
    },

    onConditionsLinkClick(e) {
        const policy = this.model.isMultiOffer() ? $(e.target).data('policy') : this.model.get('policy');
        this.widget.tracking.openCoverage(policy);
    },

    onIpidLinkClick(e) {
        const policy = this.model.isMultiOffer() ? $(e.target).data('policy') : this.model.get('policy');
        this.widget.tracking.openIpid(policy);
    },

    onNagAccepted(nagType) {
        if (nagType === Nag.NAG_TYPE.continuance) {
            Odigeo.trigger(this.widget.name + ':onContinuanceNagAccepted', this.$el);
        }

        if (nagType === Nag.NAG_TYPE.confirmation) {
            this.model.selectProduct({selected: true, policy: this.model.getLastPolicyInteractedWith()});
        }
    },

    onNagRejected(nagType) {
        if (nagType === Nag.NAG_TYPE.continuance) {
            Odigeo.trigger(this.widget.name + ':onContinuanceNagRejected');
        }

        if (nagType === Nag.NAG_TYPE.reject || nagType === Nag.NAG_TYPE.confirmation) {
            this.model.selectProduct({selected: false, policy: this.model.getLastPolicyInteractedWith()});
            this.model.setValidationFailed(false);
        }
    },

    onPendingDecision() {
        this.$cachedSelectors.pendingDecisionMsg.toggleClass('odf-hidden', false);
        Odigeo.Utils.scrollToElement(this.$cachedSelectors.pendingDecisionMsg);
    },

    parseFooterIpidLink(offer) {
        const ipidTmpl = this.getTemplateBuilder('links/ipidLink')({
            tmpl: offer,
        });
        Odigeo._.extend(offer.texts, {
            parsedFooterIpid: Odigeo.Utils.replaceCmsKeyArgs(offer.texts.footerIpid, ipidTmpl),
        });
    },

    parseFreeFlag(offer) {
        Odigeo._.extend(offer, {
            isFree: this.model.isFree(offer),
        });
    },

    parseFirstProduct(offer) {
        Odigeo._.extend(offer, {
            isFirstProduct: this.model.isFirstOffer(offer),
        });
    },

    getBaggageData() {
        return this?.model?.collection?.baggageData || {};
    },

    setHandLuggageData(offer) {
        if (offer?.policy === 'AUTO_CHECKIN') {
            const {allPieces} = this.getBaggageData();
            Odigeo._.extend(offer, {
                hasHandLuggageOnly: allPieces === 0,
            });
        }
    },
});
